/**
 * COLLECTION_MODEL wire enum + schema — SCRUM-336 (DS-020 §2.3).
 *
 * Wire source of truth for the CollectionModel axis on the folio DTO +
 * reservation charges endpoint. Must be set-equal to the domain
 * `COLLECTION_MODEL_VALUES` catalog in:
 *   apps/api/src/modules/booking/domain/reservation/value-objects/collection-model.vo.ts
 *
 * The I3 drift-gate spec enforces equality at build time (step 1b):
 *   apps/api/src/modules/payments/application/folio/__tests__/
 *     collection-model-drift-gate.spec.ts
 *
 * Mirrors the STAY_KIND_WIRE_VALUES precedent in
 * `packages/validators/src/booking/stay-kind.schema.ts`.
 */
import { z } from 'zod';
/**
 * Wire enum for the CollectionModel axis. Must be set-equal to the domain
 * `COLLECTION_MODEL_VALUES` catalog. The drift-gate test enforces equality at
 * build time.
 */
export const COLLECTION_MODEL_WIRE_VALUES = [
    'ChannelCollect',
    'PropertyCollect',
];
/** Wire schema for the CollectionModel axis (closed z.enum of COLLECTION_MODEL_WIRE_VALUES). */
export const collectionModelSchema = z.enum(COLLECTION_MODEL_WIRE_VALUES);
//# sourceMappingURL=collection-model.schema.js.map